import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const bar = dom.find('[aria-expanded]');
    const submit = dom.find('[data-submit]');
    const button = dom.find('[data-close]');
    const count = dom.find('[data-count]');
    const checkboxes = dom.find('input');
    const clear = dom.find('[data-clear]');
    const heading = dom.find('[data-heading]');
    const filters = dom.find('[data-filter]');

    let active = false;
    let initialFilters = '';
    let currentFilters = '';

    const getFilters = () => filters.find('input:checked').map(checkbox => $(checkbox).next().text()).join(', ');
    const getFiltersCount = () => currentFilters.split(',').length;
    const haveFiltersChanged = () => initialFilters !== currentFilters;

    const gotoUrl = () => {
        const url = document.location.pathname.replace(/\/side\d+/, '');
        const params = filters.map(filter => {
            const key = $(filter).data('filter');
            return {
                key,
                value: $(filter).find('input:checked').map(input => input.value).join('|')
            };
        })
            .map(filter => (filter.value.length ? `${filter.key}=${filter.value}` : false))
            .filter(value => value)
            .join('&');

        window.location.href = params.length ? `${url}?${params}` : url;
    };

    const onSubmit = e => {
        if (e) {
            e.preventDefault();
        }
        TweenLite.to(el, 0.35, { y: -60, ease: Sine.easeInOut, onComplete: gotoUrl });
    };

    const onClose = e => {
        if (e) {
            e.preventDefault();
        }
        dom.removeClass('-open');
        bar.attr('aria-expanded', false);
    };

    const open = () => {
        if (!active) {
            active = true;
            dom.addClass('-open');
            bar.attr('aria-expanded', true);
        }
    };

    const close = () => {
        if (active) {
            active = false;
            if (haveFiltersChanged()) {
                onSubmit();
            } else {
                onClose();
            }
        }
    };

    const toggle = e => {
        e.preventDefault();
        Dispatch.emit(bar.attr('aria-expanded') === 'false' ? Events.FILTERS_OPEN : Events.FILTERS_CLOSE, dom);
    };

    const update = () => {
        currentFilters = getFilters();
        const filtersHaveChanged = haveFiltersChanged();

        button.attr('hidden', filtersHaveChanged ? '' : null);
        submit.attr('hidden', filtersHaveChanged ? null : '');

        bar.toggleClass('-active', !!currentFilters.length);
        count.text(currentFilters.length ? getFiltersCount() : '');
        heading.text(currentFilters.length ? currentFilters : 'Filtre');

        filters.each(node => {
            const filter = $(node);
            filter.find('[data-clear]').attr('hidden', filter.find('input:checked').length ? null : '');
        });
    };

    const reset = e => {
        $(e.triggerTarget).parent('[data-filter]').find('input').each(checkbox => {
            checkbox.checked = false;
        });
        update();
    };

    const init = () => {
        Dispatch.on(Events.FILTERS_OPEN, open);
        Dispatch.on(Events.FILTERS_CLOSE, close);
        initialFilters = getFilters();
        bar.on('click', toggle);
        button.on('click', toggle);
        submit.on('click', toggle);
        dom.on('submit', toggle);
        clear.on('click', reset);
        checkboxes.on('change', update);
        update();
    };

    const destroy = () => {
        Dispatch.off(Events.FILTERS_OPEN, open);
        Dispatch.off(Events.FILTERS_CLOSE, close);
        bar.off('click');
        button.off('click');
        submit.off('click');
        clear.off('click');
        checkboxes.off('change');
        dom.off('submit');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FilterMenuFixed.js